module.exports = __webpack_public_path__ + "static/media/X.0c409bb2.png";